export const DEFAULT_STC_CURRENCY = {
  code: "STC",
  name: "Pts",
  label: "Points",
};

export const PRICELESS_CURRENCY_OBJ = {
  id: "PRICELESS",
  currencyKey: "PRICELESS",
  key: "priceless",
  type: "PRICELESS",
  code: "items",
  label: "Priceless",
  text: "Priceless",
  description: "Prices won't be shown in the shop. Choose how many items recipients can redeem.",
};

export const CURRENCY_HUMANIZED_MAPPING = {
  PRICELESS: "PRICELESS",
  FIAT: "USD",
};

export const DEFAULT_CURRENCY_OBJECT = { name: "US Dollar", code: "USD", symbol: "$" };
